var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgConfirmCheck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 49,
    viewBox: "0 0 50 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.128 36.822L41.878 15.072L38.456 11.534L20.128 29.92L11.544 21.278L8.122 24.7L20.128 36.822ZM25 0.571998C29.408 0.571998 33.4873 1.674 37.238 3.878C40.8727 5.966 43.734 8.82733 45.822 12.462C48.026 16.2127 49.128 20.292 49.128 24.7C49.128 29.108 48.026 33.1873 45.822 36.938C43.734 40.5727 40.8727 43.434 37.238 45.522C33.4873 47.726 29.408 48.828 25 48.828C20.592 48.828 16.5127 47.726 12.762 45.522C9.12733 43.3953 6.266 40.5147 4.178 36.88C1.974 33.1293 0.872 29.0693 0.872 24.7C0.872 20.3307 1.974 16.2707 4.178 12.52C6.30467 8.88533 9.18533 6.00466 12.82 3.878C16.5707 1.674 20.6307 0.571998 25 0.571998Z",
    fill: "#53B500"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirmCheck);
export default __webpack_public_path__ + "static/media/confirm_check.1e2373f2.svg";
export { ForwardRef as ReactComponent };